/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegistrarFarmacoPacienteDto } from '../../models/registrar-farmaco-paciente-dto';
import { RespuestaRegistrarFarmacoDto } from '../../models/respuesta-registrar-farmaco-dto';

export interface FarmacosControllerRegistrarFarmacoPaciente$Params {

/**
 * UUID del programa al que pertenece el paciente
 */
  programaUuid: string;

/**
 * UUID del fármaco a comprobar
 */
  farmacoUuid: string;
      body: RegistrarFarmacoPacienteDto
}

export function farmacosControllerRegistrarFarmacoPaciente(http: HttpClient, rootUrl: string, params: FarmacosControllerRegistrarFarmacoPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<RespuestaRegistrarFarmacoDto>> {
  const rb = new RequestBuilder(rootUrl, farmacosControllerRegistrarFarmacoPaciente.PATH, 'post');
  if (params) {
    rb.path('programaUuid', params.programaUuid, {});
    rb.path('farmacoUuid', params.farmacoUuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RespuestaRegistrarFarmacoDto>;
    })
  );
}

farmacosControllerRegistrarFarmacoPaciente.PATH = '/api/farmacos/farmacos-paciente/{programaUuid}/{farmacoUuid}';
